import { useController } from 'react-hook-form';

/**
 * This field is not interactable, it's a temporary(🤞) hack to add additional data context to `zod` validation
 */
export const ProjectTimeZone = () => {
  useController({
    name: 'projectTimeZone',
  });

  return <></>;
};
